import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { iapService } from '@/services/iap';
import { computed } from 'vue';

export function useIAPList() {
    const { list, total, fetchList } = useBaseListView({ request: iapService.list });
    const iapOptions = computed(() => list.value.map(item => ({ value: item.id, label: item.name, data: item })));

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: iapService.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, iapOptions, fetchIapOptions: fetchList, actions };
}
